"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mps_icon_library_1 = require("@imaginelearning/mps-icon-library");
var themes_enum_1 = __importDefault(require("./shared/enums/themes.enum"));
var icon_library_enum_1 = __importDefault(require("./shared/enums/icon-library.enum"));
var config = {
    defaults: {
        theme: themes_enum_1.default.STUDENT_3_5,
        themePerGradeMap: [
            themes_enum_1.default.STUDENT_K_2,
            themes_enum_1.default.STUDENT_K_2,
            themes_enum_1.default.STUDENT_K_2,
            themes_enum_1.default.STUDENT_3_5,
            themes_enum_1.default.STUDENT_3_5,
            themes_enum_1.default.STUDENT_3_5,
            themes_enum_1.default.STUDENT_6_8,
            themes_enum_1.default.STUDENT_6_8,
            themes_enum_1.default.STUDENT_6_8,
            themes_enum_1.default.STUDENT_9_12,
            themes_enum_1.default.STUDENT_9_12,
            themes_enum_1.default.STUDENT_9_12,
            themes_enum_1.default.STUDENT_9_12
        ],
        breakpoints: {
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200
        },
        basePaths: {
            avatars: "assets:avatars/"
        },
        iconLibrary: icon_library_enum_1.default.SOLID
    },
    iconLibrary: {
        regular: {
            style: "far",
            pack: mps_icon_library_1.far
        },
        light: {
            style: "fal",
            pack: mps_icon_library_1.fal
        },
        duotone: {
            style: "fad",
            pack: mps_icon_library_1.fad
        },
        solid: {
            style: "fas",
            pack: mps_icon_library_1.fas
        }
    }
};
exports.default = config;
